import {Typography} from '@mui/material';
import {doc, setDoc} from 'firebase/firestore';
import {useEffect, useRef, useState} from 'react';
import {useSearchParams} from 'react-router';
import {firebaseAuth, firebaseFirestore} from '../../setup/firebase';
import {GdriveTokenStatus} from '../../constants/gdriveTokenStatus';

export default function LinkGoogleDriveCallbackPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const code = searchParams.get('code');
    const redirectUri = `${window.location.origin}${window.location.pathname}`;

    if (!code) {
      setStatus('error');
      setMessage('Missing authorization code');
      return;
    }

    const run = async () => {
      const uid = firebaseAuth.currentUser?.uid;
      if (!uid) {
        setStatus('error');
        setMessage('Please sign in again');
        return;
      }

      try {
        const docRef = doc(firebaseFirestore, 'user', uid, 'gdriveToken', 'pending');
        await setDoc(docRef, {
          status: GdriveTokenStatus.PENDING,
          code,
          redirectUri,
          createdAt: Math.floor(Date.now() / 1000),
        });

        setStatus('success');
        setMessage('Processing... This window will close shortly.');

        if (window.opener) {
          window.opener.postMessage('gdrive-linking', window.location.origin);
        }
        window.setTimeout(() => window.close(), 1500);
      } catch (e) {
        const msg = e instanceof Error ? e.message : 'Failed to initiate linking';
        setStatus('error');
        setMessage(msg);
      }
    };

    run();
  }, [searchParams]);

  return (
    <Typography sx={{p: 2}}>
      {status === 'loading' && 'Initiating Google Drive link...'}
      {status === 'success' && message}
      {status === 'error' && `Error: ${message}`}
    </Typography>
  );
}
